import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grade-simulation-page" }
const _hoisted_2 = { class: "filter" }
const _hoisted_3 = { class: "filter-section" }
const _hoisted_4 = { class: "filter-item" }
const _hoisted_5 = { class: "filter-item" }
const _hoisted_6 = {
  key: 0,
  class: "score-table-section"
}
const _hoisted_7 = { class: "score-table" }
const _hoisted_8 = { class: "score-table" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onBlur", "onKeyup"]
const _hoisted_11 = {
  key: 1,
  class: "loading-overlay"
}
const _hoisted_12 = { class: "loading-content" }

import { getPassLine, postSimulateGrade } from '@/servers/api/analysis';
import { Button as AButton, message, Spin } from 'ant-design-vue';
import { getExamApi } from '@/servers/api/exam';
import { getGradeApi } from '@/servers/api/grade';
import { getTotalScore, getTotalClassRank, getTotalSchoolRank, getSubjectScore, getSubjectClassRank, getSubjectSchoolRank } from '@/utils/subjects';
import { useUserStore } from '@/store/modules/user';
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';

interface ScoreItem {
  subject: string;
  score: number;
  label:string;
  show: boolean;
  classRank: number;
  gradeRank: number;
  classHighest?: number;
  firstLine?: number;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'GradeSimulationPage',
  setup(__props) {

const loading = ref(false)
const userStore = useUserStore();
const userInfo = ref()
const router = useRouter();
const pass_line = ref();
//锁定学生班级
const student = localStorage.getItem('user');
const studentClassId = JSON.parse(student?? '{}').student.class_id;
//锁定学生学号
const studentId = JSON.parse(student?? '{}').student.uid;

const selectedSemester = ref<number>(0);

const selectedExam = ref<string>('');//选中的考试
const examOptions = ref<{value:number,label:string,list:{value:string,label:string}[]}[]>();//考试下拉框

const showTable = ref<boolean>(false);
const editingIndex = ref<number>(-1);
const editingScore = ref<number>(0);

// 原始成绩数据
const originalScores = ref<ScoreItem[]>([]);


// 模拟成绩数据（深拷贝原始数据）
const simulatedScores = ref<ScoreItem[]>(JSON.parse(JSON.stringify(originalScores.value)));
onMounted(async () => {
  await fetchExamOption();
  userInfo.value = userStore.userInfo;
  await inquiry();
})
// 开始编辑成绩
const startEdit = (index: number): void => {
  if (simulatedScores.value[index].subject === '总分') return;
  editingIndex.value = index;
  editingScore.value = simulatedScores.value[index].score;
};


// 完成编辑成绩
const finishEdit = (index: number): void => {
  if (editingIndex.value === -1) return;
  
  // 更新成绩
  simulatedScores.value[index].score = editingScore.value;
  
  // 计算新的班次和段次（这里使用简单的线性关系模拟）
  const score = editingScore.value;
  const classHighest = simulatedScores.value[index].classHighest;
  const firstLine = simulatedScores.value[index].firstLine;
  
  // 计算新的班次（假设是线性关系）
  if(classHighest && firstLine) {
    simulatedScores.value[index].classRank = Math.round(
      (classHighest - score) / (classHighest - firstLine) * 100
    );
    
    // 计算新的段次（假设是线性关系）
    simulatedScores.value[index].gradeRank = Math.round(
      (classHighest - score) / (classHighest - firstLine) * 500
    );
  }
  
  // 更新总分
  updateTotalScore();
  
  editingIndex.value = -1;
};

// 更新总分
const updateTotalScore = (): void => {
  const totalScore = simulatedScores.value
    .filter((item: ScoreItem) => item.subject !== '总分')
    .reduce((sum: number, item: ScoreItem) => sum + item.score, 0);
  
  simulatedScores.value[0].score = totalScore;
  
  // 更新总分的班次和段次
  const classHighest = simulatedScores.value[0].classHighest;
  const firstLine = simulatedScores.value[0].firstLine;
  
  if(classHighest && firstLine) {
    simulatedScores.value[0].classRank = Math.round(
    (classHighest - totalScore) / (classHighest - firstLine) * 100
  );
  
  simulatedScores.value[0].gradeRank = Math.round(
    (classHighest - totalScore) / (classHighest - firstLine) * 500
  );
  }
  
};

// 复位功能
const resetScores = (): void => {
  simulatedScores.value = JSON.parse(JSON.stringify(originalScores.value));
};


const goBack = (): void => {
  router.push('/analysis');
};

//定义考试下拉框的选项
const fetchExamOption = async () => {
  const res = await getExamApi({});
  console.log(res);
  examOptions.value = []
  const terms:{[key:string]:{label:string,value:string}[]} = {}

  for(let item of res.data) {
    terms[item.year] = []
  }
  let i = 0
  for(let item in terms) {
    examOptions.value.push({
      label: item,
      value: i,
      list: []
    })
    i++
  }
  for(let item of res.data) {
    for(let i in examOptions.value) {
      if(examOptions.value[i].label === item.year) {
        examOptions.value[i].list.push({
          label: item.name,
          value: item.id
        })
      }
    }
  }
  console.log(examOptions.value);
  if(res.data.length > 0){
    selectedExam.value = res.data[0].id;
  }
}
//定义查询功能score: 429.0, classRank: 72, gradeRank: 428, classHighest: 593, firstLine: 500 },
const inquiry = async() => {
    originalScores.value = []
    await getGradeApi({student_id:studentId,exam_id:Number(selectedExam.value),class_id:studentClassId}).then((res:{code:number,data:any}) => {
      originalScores.value.push({classHighest:res.data[0].topScore,show:true,subject:'总分',label:'总分',score:getTotalScore(res.data[0]),classRank:getTotalClassRank(res.data[0]),gradeRank:getTotalSchoolRank(res.data[0]) })
      originalScores.value.push({classHighest:res.data[0].topScore,show:true,subject:'语文',label:'语文',score:getSubjectScore(res.data[0],'语文'),classRank:getSubjectClassRank(res.data[0],'语文'),gradeRank:getSubjectSchoolRank(res.data[0],'语文') })
      originalScores.value.push({classHighest:res.data[0].topScore,show:true,subject:'数学',label:'数学',score:getSubjectScore(res.data[0],'数学'),classRank:getSubjectClassRank(res.data[0],'数学'),gradeRank:getSubjectSchoolRank(res.data[0],'数学') })
      originalScores.value.push({classHighest:res.data[0].topScore,show:true,subject:'英语',label:'英语',score:getSubjectScore(res.data[0],'英语'),classRank:getSubjectClassRank(res.data[0],'英语'),gradeRank:getSubjectSchoolRank(res.data[0],'英语') })
      const selected_subject = userInfo.value.student.subject_selection
      if(selected_subject.indexOf('物') === -1) {
        originalScores.value.push({classHighest:res.data[0].topScore,show:false,subject:'物理',label:'物理',score:getSubjectScore(res.data[0],'物理'),classRank:getSubjectClassRank(res.data[0],'物理'),gradeRank:getSubjectSchoolRank(res.data[0],'物理') })
      }else {
        originalScores.value.push({classHighest:res.data[0].topScore,show:true,subject:'物理',label:'物理',score:getSubjectScore(res.data[0],'物理'),classRank:getSubjectClassRank(res.data[0],'物理'),gradeRank:getSubjectSchoolRank(res.data[0],'物理') })
      }

      if(selected_subject.indexOf('化') === -1) {
        originalScores.value.push({classHighest:res.data[0].topScore,show:false,subject:'化学',label:'化学',score:getSubjectScore(res.data[0],'化学'),classRank:getSubjectClassRank(res.data[0],'化学'),gradeRank:getSubjectSchoolRank(res.data[0],'化学') })
      }else{
        originalScores.value.push({classHighest:res.data[0].topScore,show:true,subject:'化学',label:'化学',score:getSubjectScore(res.data[0],'化学'),classRank:getSubjectClassRank(res.data[0],'化学'),gradeRank:getSubjectSchoolRank(res.data[0],'化学') })
      }

      if(selected_subject.indexOf('生') === -1) {
        originalScores.value.push({classHighest:res.data[0].topScore,show:false,subject:'生物',label:'生物',score:getSubjectScore(res.data[0],'生物'),classRank:getSubjectClassRank(res.data[0],'生物'),gradeRank:getSubjectSchoolRank(res.data[0],'生物') })
      }else{
        originalScores.value.push({classHighest:res.data[0].topScore,show:true,subject:'生物',label:'生物',score:getSubjectScore(res.data[0],'生物'),classRank:getSubjectClassRank(res.data[0],'生物'),gradeRank:getSubjectSchoolRank(res.data[0],'生物') })
      }


      if(selected_subject.indexOf('政') === -1) {
        originalScores.value.push({classHighest:res.data[0].topScore,show:false,subject:'政治',label:'政治',score:getSubjectScore(res.data[0],'政治'),classRank:getSubjectClassRank(res.data[0],'政治'),gradeRank:getSubjectSchoolRank(res.data[0],'政治') })
      }else{
        originalScores.value.push({classHighest:res.data[0].topScore,show:true,subject:'政治',label:'政治',score:getSubjectScore(res.data[0],'政治'),classRank:getSubjectClassRank(res.data[0],'政治'),gradeRank:getSubjectSchoolRank(res.data[0],'政治') })
      }

      if(selected_subject.indexOf('史') === -1) {
        originalScores.value.push({classHighest:res.data[0].topScore,show:false,subject:'历史',label:'历史',score:getSubjectScore(res.data[0],'历史'),classRank:getSubjectClassRank(res.data[0],'历史'),gradeRank:getSubjectSchoolRank(res.data[0],'历史') })
      }else{
        originalScores.value.push({classHighest:res.data[0].topScore,show:true,subject:'历史',label:'历史',score:getSubjectScore(res.data[0],'历史'),classRank:getSubjectClassRank(res.data[0],'历史'),gradeRank:getSubjectSchoolRank(res.data[0],'历史') })
      }

      if(selected_subject.indexOf('地') === -1) {
        originalScores.value.push({classHighest:res.data[0].topScore,show:false,subject:'地理',label:'地理',score:getSubjectScore(res.data[0],'地理'),classRank:getSubjectClassRank(res.data[0],'地理'),gradeRank:getSubjectSchoolRank(res.data[0],'地理') })
      }else{
        originalScores.value.push({classHighest:res.data[0].topScore,show:true,subject:'地理',label:'地理',score:getSubjectScore(res.data[0],'地理'),classRank:getSubjectClassRank(res.data[0],'地理'),gradeRank:getSubjectSchoolRank(res.data[0],'地理') })
      }
      showTable.value = true;
    })
    
    getPassLine({exam_id:Number(selectedExam.value)}).then(async (res) => {
      // 行式数据按 line_group_id 分组聚合
      const grouped = new Map<number, Record<string, number>>();
      (res.data || []).forEach((row: any) => {
        const gid = row?.line_group_id;
        if (gid == null) return;
        if (!grouped.has(gid)) grouped.set(gid, {});
        if (row.subject != null && row.score != null) {
          grouped.get(gid)![row.subject] = row.score;
        }
      });
      const groups = Array.from(grouped.values());

      if(groups.length > 1) {
        if(userInfo.value.student.subject_selection.indexOf('物') !== -1) {
          // 按 line_name 分组匹配含"物"的组，需保留每组对应的 line_name
          const named = new Map<number, { name: string; dict: Record<string, number> }>();
          (res.data || []).forEach((row: any) => {
            const gid = row?.line_group_id;
            if (gid == null) return;
            if (!named.has(gid)) named.set(gid, { name: row.line_name || '', dict: {} });
            if (row.subject != null && row.score != null) {
              named.get(gid)!.dict[row.subject] = row.score;
            }
          });
          for (const [gid, val] of named) {
            if (val.name.indexOf('物') !== -1) {
              pass_line.value = val.dict;
              break;
            }
          }
        } else if(userInfo.value.student.subject_selection.indexOf('史') !== -1){
          const named = new Map<number, { name: string; dict: Record<string, number> }>();
          (res.data || []).forEach((row: any) => {
            const gid = row?.line_group_id;
            if (gid == null) return;
            if (!named.has(gid)) named.set(gid, { name: row.line_name || '', dict: {} });
            if (row.subject != null && row.score != null) {
              named.get(gid)!.dict[row.subject] = row.score;
            }
          });
          for (const [gid, val] of named) {
            if (val.name.indexOf('史') !== -1) {
              pass_line.value = val.dict;
              break;
            }
          }
        }
      }
      // 未匹配到时取第一个组
      if (!pass_line.value || Object.keys(pass_line.value).length === 0) {
        pass_line.value = groups[0] || {};
      }
      for(let item in originalScores.value) {
        originalScores.value[item].firstLine = pass_line.value[originalScores.value[item].label]
      }

      resetScores();
      await submit();
      for(let item in simulatedScores.value) {
        originalScores.value[item].classHighest = simulatedScores.value[item].classHighest
      }
    })
};
// 提交
const submit = async () => {
  loading.value = true;
  try {
    const res = await postSimulateGrade({
      exam_id: Number(selectedExam.value),
      class_id: studentClassId,
      school_id: userInfo.value.student.school,
      语文: simulatedScores.value[1].score,
      /** 英语 */
      英语: simulatedScores.value[3].score,
      /** 物理 */
      物理: simulatedScores.value[4].score,
      /** 数学 */
      数学: simulatedScores.value[2].score,
      /** 生物 */
      生物: simulatedScores.value[6].score,
      /** 历史 */
      历史: simulatedScores.value[8].score,
      /** 地理 */
      地理: simulatedScores.value[9].score,
      /** 政治 */
      政治: simulatedScores.value[7].score,
      /** 化学 */
      化学: simulatedScores.value[5].score,
      /** 总分 */
      总分: simulatedScores.value[0].score,
    });
    // 更新数据
    for(let item in simulatedScores.value) {
      if(simulatedScores.value[item].show) {
        simulatedScores.value[item].classRank = res.data[simulatedScores.value[item].label].class_rank;
        simulatedScores.value[item].gradeRank = res.data[simulatedScores.value[item].label].school_rank;
        simulatedScores.value[item].classHighest = res.data[simulatedScores.value[item].label].top_score;
      }
      
    }
    message.success('模拟考试成绩获取成功');
  } catch (error) {
    message.error('模拟考试成绩获取失败'+error);
  }finally {
    loading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "header" }, [
      _createElementVNode("button", {
        class: "back-button",
        onClick: goBack
      }, "返回"),
      _cache[3] || (_cache[3] = _createElementVNode("h2", null, "成绩模拟", -1))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("label", null, "学期:", -1)),
          _createVNode(_component_a_select, {
            value: selectedSemester.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedSemester).value = $event)),
            class: "input-select",
            options: examOptions.value
          }, null, 8, ["value", "options"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[5] || (_cache[5] = _createElementVNode("label", null, "考试:", -1)),
          (examOptions.value)
            ? (_openBlock(), _createBlock(_component_a_select, {
                key: 0,
                class: "input-select",
                options: examOptions.value[selectedSemester.value].list,
                value: selectedExam.value,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((selectedExam).value = $event))
              }, null, 8, ["options", "value"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "description red-text" }, " 说明：点击铅笔符号修改分数，点击复位按钮将所有科目改为原成绩 ", -1)),
        _createElementVNode("button", {
          onClick: inquiry,
          class: "query-button"
        }, "查询")
      ])
    ]),
    (showTable.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "table-title" }, "5.22周考", -1)),
          _createElementVNode("table", _hoisted_7, [
            _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "科目"),
                _createElementVNode("th", null, "成绩"),
                _createElementVNode("th", null, "班次"),
                _createElementVNode("th", null, "段次"),
                _createElementVNode("th", null, "班级最高分"),
                _createElementVNode("th", null, "特控线")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(originalScores.value.filter(item => item.show), (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(item.subject), 1),
                  _createElementVNode("td", null, _toDisplayString(item.score), 1),
                  _createElementVNode("td", null, _toDisplayString(item.classRank), 1),
                  _createElementVNode("td", null, _toDisplayString(item.gradeRank), 1),
                  _createElementVNode("td", null, _toDisplayString(item.classHighest), 1),
                  _createElementVNode("td", null, _toDisplayString(item.firstLine), 1)
                ]))
              }), 128))
            ])
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "table-title" }, "5.22周考模拟", -1)),
          _createElementVNode("table", _hoisted_8, [
            _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "科目"),
                _createElementVNode("th", null, "成绩"),
                _createElementVNode("th", null, "班次"),
                _createElementVNode("th", null, "段次"),
                _createElementVNode("th", null, "班级最高分"),
                _createElementVNode("th", null, "特控线")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(simulatedScores.value.filter(item => item.show), (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(item.subject) + " ", 1),
                    (item.subject !== '总分')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "edit-icon",
                          onClick: ($event: any) => (startEdit(index))
                        }, "✏️", 8, _hoisted_9))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    (editingIndex.value === index)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "number",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editingScore).value = $event)),
                          onBlur: ($event: any) => (finishEdit(index)),
                          onKeyup: _withKeys(($event: any) => (finishEdit(index)), ["enter"]),
                          class: "score-input"
                        }, null, 40, _hoisted_10)), [
                          [
                            _vModelText,
                            editingScore.value,
                            void 0,
                            { number: true }
                          ]
                        ])
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(item.score), 1)
                        ], 64))
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.classRank), 1),
                  _createElementVNode("td", null, _toDisplayString(item.gradeRank), 1),
                  _createElementVNode("td", null, _toDisplayString(item.classHighest), 1),
                  _createElementVNode("td", null, _toDisplayString(item.firstLine), 1)
                ]))
              }), 128))
            ])
          ]),
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createVNode(_unref(AButton), {
                onClick: submit,
                type: "primary"
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode("模拟", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_unref(AButton), {
                onClick: resetScores,
                type: "primary",
                danger: ""
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("复位", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_a_spin, { size: "large" }),
            _cache[13] || (_cache[13] = _createElementVNode("p", { style: {"margin-top":"16px","color":"white"} }, "正在模拟成绩，请稍等...", -1))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})